import { Modbus as ModbusSdk } from "coolremote-sdk";
import useQuery from "./useQuery";
import { IModbusLibraryTemplate, ModbusLibraryTemplateType } from "../screens/Modbus/types";

interface IUseGetModbusLibraryTemplatesOptions {
  type?: ModbusLibraryTemplateType;
  search?: string;
}

export const useGetModbusLibraryTemplates = (
  options: IUseGetModbusLibraryTemplatesOptions = {},
  enabled = true,
) => {
  return useQuery({
    queryKey: ["modbusLibraryTemplates", options.type, options.search],
    queryFn: async (): Promise<IModbusLibraryTemplate[]> => {
      const res = await ModbusSdk.getModbusLibraryTemplates(options);
      return res ?? [];
    },
    onSuccess: undefined,
    onError: undefined,
    enabled,
  });
};

export const fetchModbusLibraryTemplate = async (id: string): Promise<IModbusLibraryTemplate> => {
  return ModbusSdk.getModbusLibraryTemplate(id);
};

export const useGetModbusLibraryTemplate = (templateId: string | undefined) => {
  return useQuery({
    queryKey: ["modbusLibraryTemplate", templateId],
    queryFn: () => fetchModbusLibraryTemplate(templateId as string),
    onSuccess: undefined,
    onError: undefined,
    enabled: !!templateId,
  });
};
